import { render, staticRenderFns } from "./closures-report.vue?vue&type=template&id=677aad9e"
import script from "./closures-report.vue?vue&type=script&lang=js"
export * from "./closures-report.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports